module.exports = __webpack_public_path__ + "media/recipes/17-d0d69cdb.png";